<template>
  <div class="resourceListStatus">
    <span class="statusPill" :class="'statusPill--' + status.publication.variant">
      <span class="statusPill__dot" aria-hidden="true"></span>
      {{ status.publication.label }}
    </span>
    <el-tooltip
      v-if="status.processing"
      :content="status.processing.error || status.processing.message"
      :disabled="!status.processing.error"
      placement="top"
      popper-class="resourceListStatusTooltip"
    >
      <span
        class="resourceListStatus__processing"
        :class="'resourceListStatus__processing--' + status.processing.state"
        :tabindex="status.processing.error ? 0 : undefined"
        :aria-label="status.processing.error ? status.processing.message + '：' + status.processing.error : undefined"
      >
        <span v-for="(part, index) in status.processing.message.split(' · ')" :key="index" class="resourceListStatus__part">{{ index ? ' · ' : '' }}{{ part }}</span>
      </span>
    </el-tooltip>
  </div>
</template>

<script>
import { resourceListStatus } from './resourceListStatus'

export default {
  name: 'ResourceListStatus',
  props: { row: { type: Object, required: true } },
  computed: {
    status() { return resourceListStatus(this.row) },
  },
}
</script>

<style scoped>
.resourceListStatus {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  min-width: 0;
  padding: 3px 0;
}
.resourceListStatus__processing {
  max-width: 100%;
  font-size: var(--link-text-xs, 12px);
  line-height: 1.5;
  overflow-wrap: anywhere;
  text-wrap: balance;
  color: var(--link-ink-muted, #625e58);
}
.resourceListStatus__processing--pending,
.resourceListStatus__processing--paused,
.resourceListStatus__processing--partial {
  color: var(--link-status-warning-ink, #854d0e);
}
.resourceListStatus__part {
  display: inline-block;
  white-space: nowrap;
}
.resourceListStatus__processing--failed {
  color: var(--link-status-error-ink, #b91c1c);
}
.resourceListStatus__processing[tabindex]:focus-visible {
  outline: 2px solid currentColor;
  outline-offset: 3px;
  border-radius: 2px;
}
</style>

<style>
.resourceListStatusTooltip {
  max-width: 320px;
  white-space: pre-line;
  overflow-wrap: anywhere;
}
</style>
